export const RADIO_MODEL = 'radio';

export type RadioSeedType = 'artist' | 'genre' | 'track';

export interface Radio {
  id: number;
  name: string;
  image?: string;
  seed_type: RadioSeedType;
  seed_id: number;
  model_type: 'radio';
}
